import { Component, Input, ViewEncapsulation } from '@angular/core'

export enum PasswordStrength {
  None = 'None',
  Poor = 'Poor',
  Medium = 'Medium',
  Good = 'Good',
}

@Component({
  selector: 'ftr-password-strength-meter',
  templateUrl: './password-strength-meter.component.html',
  styleUrls: ['./password-strength-meter.component.css'],
  host: { class: 'checkbox input input--checkbox' },
  encapsulation: ViewEncapsulation.None,
})

/**
 * A progress bar like component to display the password strength based
 * on the inputted passwordStrength prop.
 */
export class PasswordStrengthMeterComponent {
  /**
   * Current strength of password
   */
  @Input() passwordStrength: PasswordStrength

  readonly strengths = PasswordStrength
}
